import { render } from "./QNAPage.vue?vue&type=template&id=4bbcd113&scoped=true"
import script from "./QNAPage.vue?vue&type=script&lang=js"
export * from "./QNAPage.vue?vue&type=script&lang=js"

import "./QNAPage.vue?vue&type=style&index=0&id=4bbcd113&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbcd113"]])

export default __exports__